import { PLATFORM_REPORT_ACTIONS } from "../actions/platformReport.actions";

const initialState = {
  campaigns: null,              
  loading: false,            
  error: null,                
};

const platformReportReducer = (state = initialState, action) => {
    const { type, payload } = action;
    // console.log(payload, "payload111"); // Log the payload to verify its structure
    
  switch (type) {
    case PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_LOADING:
      return {
        ...state,
        loading: true,       
        error: null,       
      };

    case PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_LOADED:
      return {
        ...state,
        loading: false,      
        campaigns: [{ campaign_id: 'all', title: "All" }, ...payload],
        error: null,        
      };

    case PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_FAILURE:
      return {
        ...state,
        loading: false,     
        campaigns: [],     
        error: payload, 
      };

    default:
      return state;
  }
};

export default platformReportReducer;
